"use client";

import NotFoundView from "@/components/shared/not-found-view";

export default function ErrorPage() {
    return <NotFoundView/>;
}
